import { render } from "./ProjectCalculations.vue?vue&type=template&id=10dba925"
import script from "./ProjectCalculations.vue?vue&type=script&lang=js"
export * from "./ProjectCalculations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__